import { useShowOverlayTitle } from 'containers/CarouselsDisplay/components/ContentsCarouselContainer/hooks/useShowOverlayTitle';
import React from 'react';
import { useSelector } from 'react-redux';
import {
  getGridDynamicImage,
  getGridSecondaryImage,
  shouldRenderDynamicOverlayImg,
  shouldRenderOverlayImage,
} from '../../utils';
import './style.scss';

export const WhatIncludesGridImg = ({
  isAddon,
  isMobile,
  className,
  onError,
  altText,
  styles,
  contentInfo,
  position,
  isDynamicImg = false,
}) => {
  const assets = useSelector(state => state.asset);
  const overlayImg = assets?.LandingComercial_ImagenPromocional_Overlay;
  const { showOverlay } = useShowOverlayTitle(contentInfo[position]);

  const canImageOverlay = isDynamicImg
    ? shouldRenderDynamicOverlayImg(contentInfo,isMobile)
    : shouldRenderOverlayImage(contentInfo, position, isMobile);

  const displayLandingOverlay =
    isAddon && showOverlay && canImageOverlay;

  const gridImg = isDynamicImg
    ? getGridDynamicImage(contentInfo, isMobile)
    : getGridSecondaryImage(contentInfo, position, isMobile);

  return (
    <div className={`${className} landing-img-container`} style={{ ...styles }}>
      {displayLandingOverlay && (
        <div className={'landing-img-container__over'}>
          <img className="landing-img-container__over__img" src={overlayImg} />
          <span className="landing-img-container__over__title">
            {' '}
            {contentInfo[position]?.title}{' '}
          </span>
        </div>
      )}
      <img
        src={gridImg}
        style={{ ...styles }}
        onError={onError}
        alt={altText}
      />
    </div>
  );
};
